<main [attr.e2e-attr]="MAIN_CONTEXT_E2E_ATTRIBUTE">
  <router-outlet></router-outlet>
  <router-outlet name="popup"></router-outlet>
  <modal-container refType="host"></modal-container>
  <toast-container></toast-container>
</main>
